function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*------------------------------------------------------------------
External Modules
------------------------------------------------------------------*/

// Import GSAP 3
import { gsap } from 'gsap';

/*------------------------------------------------------------------
Functions
------------------------------------------------------------------*/

function cardinal(data, closed, tension) {
  if (data.length < 1) return "M0 0";
  if (tension == null) tension = 1;
  var size = data.length - (closed ? 0 : 1);
  var path = "M" + data[0].x + " " + data[0].y + " C";
  for (var i = 0; i < size; i++) {
    var p0 = void 0,
      p1 = void 0,
      p2 = void 0,
      p3 = void 0;
    if (closed) {
      p0 = data[(i - 1 + size) % size];
      p1 = data[i];
      p2 = data[(i + 1) % size];
      p3 = data[(i + 2) % size];
    } else {
      p0 = i == 0 ? data[0] : data[i - 1];
      p1 = data[i];
      p2 = data[i + 1];
      p3 = i == size - 1 ? p2 : data[i + 2];
    }
    var x1 = p1.x + (p2.x - p0.x) / 6 * tension;
    var y1 = p1.y + (p2.y - p0.y) / 6 * tension;
    var x2 = p2.x - (p3.x - p1.x) / 6 * tension;
    var y2 = p2.y - (p3.y - p1.y) / 6 * tension;
    path += " " + x1 + " " + y1 + " " + x2 + " " + y2 + " " + p2.x + " " + p2.y;
  }
  return closed ? path + "z" : path;
}
function random(min, max) {
  if (max == null) {
    max = min;
    min = 0;
  }
  if (min > max) {
    var tmp = min;
    min = max;
    max = tmp;
  }
  return min + (max - min) * Math.random();
}

/*------------------------------------------------------------------
Create Blob
------------------------------------------------------------------*/
var BlobController = /*#__PURE__*/function () {
  function BlobController(el) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, BlobController);
    this.element = el;
    this.points = [];
    this.paths = _toConsumableArray(this.element.querySelectorAll('path'));
    this.blob = '';
    this.initialized = false;
    this.options = Object.assign({
      activeClass: 'js-active',
      numPoints: 10,
      centerX: 500,
      centerY: 500,
      minRadius: 300,
      maxRadius: 340,
      minDuration: 1,
      maxDuration: 2
    }, options);
    this.slice = Math.PI * 2 / this.options.numPoints;
    this.startAngle = random(Math.PI * 2);
    this.timeline = gsap.timeline({
      onUpdate: function onUpdate() {
        return _this.update();
      }
    });
    for (var i = 0; i < this.options.numPoints; i++) {
      var angle = this.startAngle + i * this.slice;
      var duration = random(this.options.minDuration, this.options.maxDuration);
      var point = {
        x: this.options.centerX + Math.cos(angle) * this.options.minRadius,
        y: this.options.centerY + Math.sin(angle) * this.options.minRadius
      };
      var tween = gsap.to(point, duration, {
        x: this.options.centerX + Math.cos(angle) * this.options.maxRadius,
        y: this.options.centerY + Math.sin(angle) * this.options.maxRadius,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
        // ease: Sine.easeInOut
      });

      this.timeline.add(tween, -random(duration));
      this.points.push(point);
    }
  }
  _createClass(BlobController, [{
    key: "update",
    value: function update() {
      var _this2 = this;
      // Make sure the user has not opted out of animations
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches === false || this.initialized === false) {
        this.initialized = true;
        this.blob = cardinal(this.points, true, 1);
        this.paths.forEach(function (path) {
          if (path.classList.contains(_this2.options.activeClass)) {
            window.requestAnimationFrame(function () {
              path.setAttribute("d", _this2.blob);
            });
          }
        });
      }
    }
  }, {
    key: "start",
    value: function start() {
      var _this3 = this;
      this.timeline.play();
      this.element.classList.add(this.options.activeClass);
      this.paths.forEach(function (path) {
        return path.classList.add(_this3.options.activeClass);
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this4 = this;
      this.timeline.pause();
      this.element.classList.remove(this.options.activeClass);
      this.paths.forEach(function (path) {
        return path.classList.remove(_this4.options.activeClass);
      });
    }
  }]);
  return BlobController;
}();
export { BlobController as default };